import React, { useState, useEffect } from 'react'

import { processFIX } from './utilsfixparser'
import { useTTFix } from './utilsfixparserxml'
import envConfig from '../../utils/envConfig'

import { Box, Text, TextArea, Button, Grid } from "grommet"
import AgDataTable from '../common/AgDataTable'

import Warn from '../common/Warn'

import axios from 'axios'

import { gql, useSubscription } from '@apollo/client';

import { DownloadTriageFile } from '../triage/TriageFile'
import { useDefaultConf } from '../triage/TriageHeaders'

const TASK_QUERY = gql`
subscription($taskId: String!) {
    jobtask(where: {taskid: {_eq: $taskId}}) {
        taskid
        result
        status
      }
}
`

let BC_SAMPLE = `Recv | 2020-05-25T06:39:53.770518Z | 8=FIX.4.2 9=399 35=D 34=1088 49=GHFFORTHOR_FT 50=FS01858167 52=20200525-06:39:53.798 56=TT_ORDER 116=FIX_FORT01_FT 1=HFORTHCL 11=12020052500000015 22=96 38=4 40=2 44=17250 48=7967503326640145002 54=1 55=SI 59=1 77=C 100=XCEC 167=FUT 207=CME 453=2 448=3 452=3 2376=23 447=P 448=3 452=12 2376=24 447=P 528=A 1031=Y 1724=5 2593=1 2594=3 2595=N 16558=FS01858167 16847=TT_OCO 16848=1 16903=1 16913=17515 16915=2 16916=1 10=242
Send | 2020-05-25T06:39:55.228157Z | 8=FIX.4.2 9=01215 35=8 49=TT_ORDER 56=GHFFORTHOR_FT 34=1098 50=FS01858167 142=HK 52=20200525-06:39:55.228 129=FIX_FORT01_FT 37=184f669d-2822-4427-9baa-4a25ea086b94 527=184f669d-2822-4427-9baa-4a25ea086b94:1 11=12020052500000015 41=12020052500000015 10011=17 453=2 448=3 452=3 2376=23 447=P 448=3 452=12 2376=24 447=P 17=184f669d-2822-4427-9baa-4a25ea086b94:1 20=0 150=0 39=0 1=HFORTHCL 55=SI 107=Silver 460=2 48=7967503326640145002 167=FUT 200=202007 541=20200729 205=29 207=CME 100=XCEC 461=F 15=USD 18211=M 54=1 38=4 40=2 44=17250 59=1 151=4 14=0 6=0 60=20200525-06:39:55.136432 442=1 1028=N 18216=aurora.2.algoserver_exec 528=A 10553=futures@forthright-sec.com 18220=GHF 18221=MC 18223=202007 454=4 455=SIN0 456=98 455=SI Jul20 456=97 455=1SIN0 456=5 455=22610 456=8 957=11 958=TTStopTriggerPriceType 959=1 960=3 958=ParentTIF 959=1 960=2 958=TTStopSecondTriggerPriceType 959=1 960=3 958=WaitingOption 959=1 960=0 958=TTStopTriggeredOrderType 959=1 960=2 958=user_disconnect_action 959=1 960=0 958=OcoStopTriggerPrice 959=7 960=17515.000000 958=ChildTIF 959=1 960=1 958=StopOrderType 959=1 960=1 958=StopLimitOffset 959=1 960=2 958=Algo Name 959=14 960=TT_OCO 1724=5 2593=1 2594=3 2595=N 16558=FS01858167 16117=10 18226=15 1031=Y 10=001
Recv | 2020-05-25T06:40:23.039450Z | 8=FIX.4.2 9=85 35=0 34=1089 49=GHFFORTHOR_FT 52=20200525-06:40:23.067 56=TT_ORDER 116=FIX_FORT01_FT 10=154
Send | 2020-05-25T06:40:25.228661Z | 8=FIX.4.2 9=00067 35=0 49=TT_ORDER 56=GHFFORTHOR_FT 34=1099 52=20200525-06:40:25.228 10=123
Send | 2020-05-25T06:40:26.087778Z | 8=FIX.4.2 9=01417 35=8 49=TT_ORDER 56=GHFFORTHOR_FT 34=1100 50=FS01858167 142=HK 52=20200525-06:40:26.087 129=FIX_FORT01_FT 37=184f669d-2822-4427-9baa-4a25ea086b94 527=184f669d-2822-4427-9baa-4a25ea086b94:3 11=12020052500000015 41=12020052500000015 453=2 448=3 452=3 2376=23 447=P 448=3 452=12 2376=24 447=P 17=184f669d-2822-4427-9baa-4a25ea086b94:3 20=0 150=D 39=0 378=99 1=HFORTHCL 55=SI 107=Silver 460=2 48=7967503326640145002 167=FUT 200=202007 541=20200729 205=29 207=CME 100=XCEC 461=F 15=USD 18211=M 54=1 38=4 40=2 44=17250 59=1 151=4 14=0 6=0 60=20200525-06:40:25.995951 1138=0 58=Child request timed out 442=1 1028=N 18216=aurora.2.algoserver_exec 528=A 10553=futures@forthright-sec.com 18220=GHF 18221=MC 18223=202007 454=4 455=SIN0 456=98 455=SI Jul20 456=97 455=1SIN0 456=5 455=22610 456=8 957=15 958=TTStopTriggerPriceType 959=1 960=3 958=ParentTIF 959=1 960=2 958=TTStopSecondTriggerPriceType 959=1 960=3 958=WaitingOption 959=1 960=0 958=TTStopTriggeredOrderType 959=1 960=2 958=user_disconnect_action 959=1 960=0 958=OcoStopTriggerPrice 959=7 960=17515.000000 958=ChildTIF 959=1 960=1 958=StopOrderType 959=1 960=1 958=StopLimitOffset 959=1 960=2 958=Algo Name 959=14 960=TT_OCO 958=enable_near_far_touch_price_reasonability 959=13 960=N 958=enable_algo_risk_checks 959=13 960=N 958=ScheduleSeed 959=1 960=1855575461 958=_ladder_display 959=1 960=0 1724=5 2593=1 2594=3 2595=N 16558=FS01858167 16117=10 18226=15 1031=Y 10=242
Send | 2020-05-25T06:40:26.090181Z | 8=FIX.4.2 9=01383 35=8 49=TT_ORDER 56=GHFFORTHOR_FT 34=1101 50=FS01858167 142=HK 52=20200525-06:40:26.090 129=FIX_FORT01_FT 37=184f669d-2822-4427-9baa-4a25ea086b94 527=184f669d-2822-4427-9baa-4a25ea086b94:4 11=12020052500000015 41=12020052500000015 453=2 448=3 452=3 2376=23 447=P 448=3 452=12 2376=24 447=P 17=184f669d-2822-4427-9baa-4a25ea086b94:4 20=0 150=4 39=4 1=HFORTHCL 55=SI 107=Silver 460=2 48=7967503326640145002 167=FUT 200=202007 541=20200729 205=29 207=CME 100=XCEC 461=F 15=USD 18211=M 54=1 38=4 40=2 44=17250 59=1 151=0 14=0 6=0 60=20200525-06:40:25.998663 1138=0 442=1 1028=N 18216=aurora.2.algoserver_exec 528=A 10553=futures@forthright-sec.com 18220=GHF 18221=MC 18223=202007 454=4 455=SIN0 456=98 455=SI Jul20 456=97 455=1SIN0 456=5 455=22610 456=8 957=15 958=TTStopTriggerPriceType 959=1 960=3 958=ParentTIF 959=1 960=2 958=TTStopSecondTriggerPriceType 959=1 960=3 958=WaitingOption 959=1 960=0 958=TTStopTriggeredOrderType 959=1 960=2 958=user_disconnect_action 959=1 960=0 958=OcoStopTriggerPrice 959=7 960=17515.000000 958=ChildTIF 959=1 960=1 958=StopOrderType 959=1 960=1 958=StopLimitOffset 959=1 960=2 958=Algo Name 959=14 960=TT_OCO 958=enable_near_far_touch_price_reasonability 959=13 960=N 958=enable_algo_risk_checks 959=13 960=N 958=ScheduleSeed 959=1 960=1855575461 958=_ladder_display 959=1 960=0 1724=5 2593=1 2594=3 2595=N 16558=FS01858167 16117=10 18226=15 1031=Y 10=047
Send | 2020-05-25T06:40:26.270632Z | 8=FIX.4.2 9=00668 35=8 49=TT_ORDER 56=GHFFORTHOR_FT 34=1102 52=20200525-06:40:26.270 129=FIX_FORT01_FT 37=184f669d-2822-4427-9baa-4a25ea086b94 527=184f669d-2822-4427-9baa-4a25ea086b94:1590388826179269 41=12020052500000015 10011=18 17=184f669d-2822-4427-9baa-4a25ea086b94:1590388826179269 20=0 150=4 39=4 1=HFORTHCL 55=SI 107=Silver 460=2 48=7967503326640145002 167=FUT 200=202007 541=20200729 205=29 207=CME 100=XCEC 461=F 15=USD 18211=M 59=1 151=0 14=0 6=0 60=20200525-06:40:26.179276 442=1 1028=N 18216=aurora.2.algoserver_exec 10553=futures@forthright-sec.com 18220=GHF 18221=MC 18223=202007 454=4 455=SIN0 456=98 455=SI Jul20 456=97 455=1SIN0 456=5 455=22610 456=8 16117=10 18226=7 10=068`


const FixParserHome = ({ content = false }) => {

    const t3_url = envConfig[process.env.REACT_APP_ENVIRONMENT]['t3_url']
    const [fixMessages, setFixMessages] = useState(BC_SAMPLE)
    const [selectedRow, setSelectedRow] = useState({})
    const [fixVersion, setFixVersion] = useState(null)
    const [parsedFix, setParsedFix] = useState(null)

    const [triageFileURL, setTriageFileURL] = useState('')
    const resultFile = DownloadTriageFile(triageFileURL)

    const { data: taskResult, loading: taskDataLoading } = useSubscription(
        TASK_QUERY, { variables: { taskId: content ? content.taskid : '' } }
    )
    const axiosConf = useDefaultConf()

    useEffect(() => {
        if (resultFile && resultFile.data) {
            setFixMessages(resultFile.data)
        }
    }, [resultFile])

    useEffect(() => {

        async function getStatusResponse() {
            const response = await axios(
                t3_url + '/api/1/taskstatus/' + content.taskid, axiosConf
            )

            // Gather From Triage File if Present
            if (response.data && response.data.results && response.data.results.triage_files) {
                setTriageFileURL(response.data.results.triage_files[0])
                console.log(triageFileURL)
            }

            if (response.data && response.data.results && response.data.results.raw_send_recv) {
                setFixMessages(response.data.results.raw_send_recv.join("\n"))
            }
        }

        if (content && !taskDataLoading && taskResult && taskResult.jobtask &&
            taskResult.jobtask.length > 0 && taskResult.jobtask[0].status !== 0
            && !(content.taskid.includes("MANUAL"))) {
            getStatusResponse()
        }
    }, [axiosConf, content, taskDataLoading, taskResult, t3_url, triageFileURL])

    useEffect(() => {
        if (fixMessages && fixMessages.length > 0) {
            if (fixMessages.indexOf("8=FIX.4.2") > -1) {
                setFixVersion(42)
            } else if (fixMessages.indexOf("8=FIX.4.4") > -1) {
                setFixVersion(44)
            }
            setParsedFix(processFIX(fixMessages))
        }
    }, [fixMessages, taskResult])

    useEffect(() => {
        // Select First Row
        if (parsedFix && parsedFix.length > 0 && parsedFix[0] && parsedFix[0].lookup) {
            setSelectedRow(parsedFix[0].lookup[52] + "|" + parsedFix[0].lookup[9] + "|" + parsedFix[0].lookup[34])
        }
    }, [parsedFix])

    const handleClick = (params) => {
        setSelectedRow(params.uniqueId)
    }

    const fixData = useTTFix(fixVersion)

    return (

        <Box fill background="light-1" align="start" overflow={{ horizontal: 'hidden', vertical: 'hidden' }} pad="small">

            <Grid
                rows={['100%', '100%']}
                columns={['55%', '45%']}
                fill="horizontal"
                gap="3px"
                areas={[
                    { name: 'left', start: [0, 0], end: [0, 0] },
                    { name: 'right', start: [1, 0], end: [1, 0] },
                ]}
            >

                <Box margin={{ left: "10px", top: "5px" }} fill gridArea="left" overflow={{ horizontal: 'hidden', vertical: 'auto' }}>

                    {!content &&
                        <>
                            <Box margin={{ top: "small", left: "5px" }} direction="row" height="30px">
                                <Text pad="small" size="medium" color="brand" weight="bold">Fix Parser</Text>
                                <Button alignSelf="center" margin={{ left: "10px" }} size="small" primary onClick={() => setFixMessages(BC_SAMPLE)} label={<Text size="14px">Insert Sample Fix Data</Text>} />
                                <Button alignSelf="center" margin={{ left: "10px" }} size="small" href="https://library.tradingtechnologies.com/tt-fix/directory.html" target="_blank" primary label={<Text size="14px">TTFIX Tag Library</Text>} />
                                <Button alignSelf="center" margin={{ left: "10px" }} size="small" primary onClick={() => setFixMessages("")} label={<Text size="14px">Clear</Text>} />
                            </Box>

                            <Box margin={{ bottom: "medium", top: "small", left: "5px" }}>
                                <Text pad="xsmall" size="small">This parser is compatible with TTFIX 4.2 or 4.4 Production Version</Text>
                                <Text pad="xsmall" size="small">Send and recv log tags must be separated by space or '^A' or '|'.</Text>
                            </Box>
                            <Box pad="xsmall" height="300px">
                                <TextArea
                                    placeholder="Paste Fix Output Here"
                                    value={fixMessages}
                                    fill
                                    focusIndicator={true}
                                    resize="vertical"
                                    onChange={event => setFixMessages(event.target.value)}
                                />
                            </Box>
                        </>
                    }

                    {content &&
                        <Box width="170px">
                            <Button margin={{ left: "5px" }} size="small" href="https://library.tradingtechnologies.com/tt-fix/directory.html" target="_blank" primary label={<Text size="14px">TTFIX Tag Library</Text>} />
                        </Box>
                    }

                    {parsedFix && parsedFix === "No well formed FIX string found" &&
                        <Box margin={{ top: "30px" }}>
                            <Warn warning={"No well formed FIX string found"} />
                        </Box>
                    }

                    {fixMessages.length > 0 && parsedFix && parsedFix !== "No well formed FIX string found" && fixVersion && fixData && Object.keys(parsedFix).length > 0 && Object.keys(fixData).length > 0 &&
                        <TimeLineTable data={parsedFix} handleClick={handleClick} fixData={fixData} />
                    }

                </Box>

                {fixMessages.length > 0 && parsedFix && parsedFix !== "No well formed FIX string found" && fixVersion && fixData && Object.keys(parsedFix).length > 0 && selectedRow && Object.keys(fixData).length > 0 && Object.keys(selectedRow).length > 0 &&
                    <Detail data={parsedFix} selectedRow={selectedRow} fixData={fixData} />
                }
            </Grid>

        </Box>

    )

}

export const TimeLineTable = ({ data, handleClick, fixData }) => {

    const [skipHeartBeats, setSkipHearBeats] = useState(false)

    const tab_col = [
        {
            field: "datetimeparsed",
            headerName: "DateTime",
            minWidth: 150,
        },
        {
            field: "sender",
            headerName: "Sender",
            minWidth: 150,
        },
        {
            field: "target",
            headerName: "Target",
            minWidth: 150,
        },
        {
            field: "message",
            headerName: "Message",
            minWidth: 150,
            cellStyle: function (params) {
                if (params.node.data.message === "HEARTBEAT") {
                    return { color: 'white', backgroundColor: '#A6A6A6' };
                }
            }
        },
        {
            field: "orderid",
            headerName: "Client Order ID",
            minWidth: 150,
        },
    ]

    const [tab_data, settab_data] = useState([])
    const [removed_entries, setremoved_entries] = useState(0)

    useEffect(() => {
        let tab_dat_temp = []
        let unique_entry = []
        let removed_entries_in = 0

        function translateEnum(tag, value) {
            const lookup = fixData[tag].enum
            return lookup[value]
        }

        data.forEach(message => {
            if (skipHeartBeats && translateEnum(35, message.lookup[35]) === "HEARTBEAT") return null
            const uniqueId = message.lookup[52] + "|" + message.lookup[9] + "|" + message.lookup[34]
            let _data = {
                "uniqueId": uniqueId,
                "datetime": message.lookup[52],
                "sender": message.lookup[49],
                "target": message.lookup[56],
                "message": translateEnum(35, message.lookup[35]),
                "orderid": message.lookup[11],
                "datetimeparsed": message.lookup[52]
            }

            // Remove duplicated entries
            if (!unique_entry.includes(uniqueId)) {
                tab_dat_temp.push(_data)
            } else {
                removed_entries_in = removed_entries_in + 1
                setremoved_entries(removed_entries_in)
            }
            unique_entry.push(uniqueId)
        });
        settab_data(tab_dat_temp)
    }, [data, skipHeartBeats, fixData])

    return (
        <Box margin={{ top: "10px" }} fill pad="xsmall" gap="small">
            {removed_entries > 0 && <Warn warning="Duplicate FIX Messages Detected" subWarning={"Removed " + removed_entries + " duplicated FIX Messages from input above"} />}
            <Box direction="row">
                <Text margin={{ left: "10px" }} pad="small" size="medium" color="brand" weight="bold">Timeline</Text>
                <Button color={skipHeartBeats ? "ttdown" : "ttok"} margin={{ left: "20px" }} size="small" primary onClick={() => setSkipHearBeats(!skipHeartBeats)} label={<Text size="14px">Hide HeartBeats</Text>} />
            </Box>
            <AgDataTable
                tab_col={tab_col}
                tab_data={tab_data}
                tableName="Fix Timeline2"
                handleClick={handleClick}
                tableHeight={475}
            />
        </Box>
    )
}

export const Detail = ({ data, selectedRow, fixData }) => {

    const [skipCommon, setSkipCommon] = useState(false)

    const [selectedRowData, setselectedRowData] = useState({})

    useEffect(() => {
        data.forEach(row => {
            if (row.lookup[52] + "|" + row.lookup[9] + "|" + row.lookup[34] === selectedRow) {
                setselectedRowData(row)
            }
        });
    }, [data, selectedRow])

    const COMMON_FIELDS = [8, 9, 34, 49, 52, 56, 10]
    const tab_col = [
        {
            field: "tag",
            headerName: "Tag",
            minWidth: 120
        },
        {
            field: "tagdesc",
            headerName: "Tag Description",
            cellStyle: function (params) {
                if (COMMON_FIELDS.includes(parseInt(params.node.data.tag))) {
                    return { color: 'white', backgroundColor: '#A6A6A6' };
                }
            },
            minWidth: 200,
        },
        {
            field: "value",
            headerName: "Value",
            minWidth: 200,
        },
        {
            field: "valuedesc",
            headerName: "Value Description",
            minWidth: 200,
        },
    ]
    const [tab_data, settab_data] = useState([])

    useEffect(() => {
        let tab_data_temp = []

        const COMMON_FIELDS = [8, 9, 34, 49, 52, 56, 10]
        function translateEnum(tag, value) {
            const lookup = fixData[tag].enum
            return lookup[value]
        }

        selectedRowData && Object.keys(selectedRowData).length > 0 && selectedRowData.lookup && Object.keys(selectedRowData.lookup).forEach(tag => {
            if (Number.isInteger(parseInt(tag)) === false) return null // there are some non numeric tags
            if (skipCommon && COMMON_FIELDS.includes(parseInt(tag))) return null
            let _data = {
                "uniqueId": tag,
                "tag": tag,
                "tagdesc": fixData[tag] ? fixData[tag].desc : "UNKNOWN",
                "value": selectedRowData.lookup[tag],
                "valuedesc": fixData[tag] ? translateEnum(tag, selectedRowData.lookup[tag]) : "UNKNOWN"
            }
            tab_data_temp.push(_data)
        });
        settab_data(tab_data_temp)
    }, [fixData, selectedRowData, skipCommon])

    function translateEnumOut(tag, value) {
        const lookup = fixData[tag].enum
        return lookup[value]
    }

    return (
        <Box margin={{ top: "30px" }} fill gridArea="right">
            <Box direction="row">
                <Text margin={{ left: "10px" }} pad="small" size="small" color="brand" weight="bold">{"Detail for " + translateEnumOut(35, selectedRow.split("|")[1]) + " at " + selectedRow.split("|")[0]}</Text>
                <Button color={skipCommon ? "ttdown" : "ttok"} margin={{ left: "20px" }} size="small" primary onClick={() => setSkipCommon(!skipCommon)} label={<Text size="14px">Hide Common Tags</Text>} />
            </Box>
            <AgDataTable
                tab_col={tab_col}
                tab_data={tab_data}
                tableName="Fix Detail2"
                paginationPageSize={100}
                tableHeight={610}
            />
        </Box>
    )
}

export default FixParserHome
